import styles from './index.module.scss';

const SearchHitSkeleton: React.FC = () => {
  return (
    <div className={styles['hit-placeholder']}>
      <div className={styles['hit-placeholder__header']}>
        <div className={styles['hit-placeholder__title']} />
        <div className={styles['hit-placeholder__icon']} />
      </div>
      <div className={styles['hit-placeholder__intro']} />
    </div>
  );
};

export default SearchHitSkeleton;
